import { motion } from "framer-motion";
import { MapPin, Clock3, Route, Phone } from "lucide-react";
import { useExperience } from "@/context/ExperienceContext";
import { BUSINESS } from "@/config/business";
import { EligibilityQuiz } from "./EligibilityQuiz";
import { CtaButton } from "./CtaButton";

const INFO = [
  { icon: Phone, label: "Phone", value: `${BUSINESS.phoneDisplay} (placeholder)`, id: "phone" },
  { icon: MapPin, label: "Address", value: BUSINESS.address, id: "address" },
  { icon: Clock3, label: "Hours", value: BUSINESS.hours, id: "hours" },
  { icon: Route, label: "Service area", value: BUSINESS.serviceArea, id: "service-area" },
];

export function FinaleSection() {
  const { finale } = useExperience();
  return (
    <section id="enroll" data-testid="finale-section" className="rrb-finale">
      <div className="mx-auto grid max-w-6xl items-start gap-10 px-5 lg:grid-cols-[1fr_1.15fr] lg:gap-14">
        <motion.div initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.3 }} transition={{ duration: 0.7 }}>
          <p className="rrb-eyebrow">Now enrolling · Open 24 hours</p>
          <h2 className="font-display text-4xl font-semibold leading-[1.05] sm:text-5xl">
            See if your family may qualify for <span className="rrb-free">FREE</span> child care.
          </h2>
          <p className="mt-4 max-w-md text-base opacity-80 sm:text-lg">Helping hundreds of Dallas parents — day, evening, and overnight. It takes about a minute.</p>
          <div className="mt-6 flex flex-wrap gap-2">
            <CtaButton kind="enroll" size="sm" testId="finale-enroll-btn" />
            <CtaButton kind="tour" size="sm" testId="finale-tour-btn" />
            <CtaButton kind="transportation" size="sm" testId="finale-transportation-btn" />
            <CtaButton kind="call" size="sm" testId="finale-call-btn" />
          </div>
        </motion.div>
        <motion.div className="rrb-quiz-card" data-testid="finale-quiz-card"
          style={{ transform: `translateY(${(1 - finale) * 60}px)` }}>
          <EligibilityQuiz scene="eligibility-finale" />
        </motion.div>
      </div>
      <footer className="mx-auto mt-20 max-w-6xl px-5 pb-28 md:pb-10" data-testid="site-footer">
        <div className="rrb-info-grid">
          {INFO.map(({ icon: Icon, label, value, id }) => (
            <div key={id} data-testid={`footer-${id}`} className="rrb-info">
              <Icon className="h-4 w-4" />
              <div><span>{label}</span><p>{value}</p></div>
            </div>
          ))}
        </div>
        <div className="mt-8 flex flex-wrap items-center justify-between gap-4 text-xs opacity-60">
          <span>© {new Date().getFullYear()} {BUSINESS.name} · {BUSINESS.city}</span>
          <a href="/staff/login" data-testid="footer-staff-link" className="underline-offset-4 hover:underline">Staff sign in</a>
        </div>
      </footer>
    </section>
  );
}
